import { SANDBOX_PRESET_TAG as T } from '../presetTags'
import { SANDBOX_PRESET_BODY_CSS, type SandboxComponentPreset } from '../../sandboxPresetTypes'

/**
 * **Stroke drawing**: set `stroke-dasharray` ≈ path length so the dash covers the path once; start with
 * `stroke-dashoffset` equal to that length (invisible), animate offset to 0 (fully drawn). Replay = remove
 * class, force layout (`getBoundingClientRect`), re-add class to retrigger CSS animation.
 */
const shell = SANDBOX_PRESET_BODY_CSS

const preset: SandboxComponentPreset = {
  id: 'svg-stroke-draw',
  category: 'motion-svg',
  title: 'SVG stroke draw',
  description: 'Curved path with animated stroke-dashoffset (CSS).',
  tags: [T.svg, T.animation],
  html: `<h2>Drawn path</h2>

<svg viewBox="0 0 100 60" width="240" height="144" aria-hidden="true">
  <!-- Cubic Bézier: d=… defines the curve; stroke animates, no fill -->
  <path id="curve" class="anim" fill="none" stroke="var(--nogrok-preview-primary)" stroke-width="3" d="M5,45 C25,5 75,5 95,45"></path>
</svg>
<p class="small">Replay: <button type="button" id="replay">Run</button></p>`,
  css: `${shell}

h2 {
  color: var(--nogrok-preview-primary);
  margin: 0 0 0.5rem;
}

/* dasharray/offset tuned ~path length; forwards keeps final state */
#curve.anim {
  stroke-dasharray: 120;
  stroke-dashoffset: 120;
  animation: draw 2s ease forwards;
}

@keyframes draw {
  to {
    stroke-dashoffset: 0;
  }
}

.small {
  font-size: 0.85rem;
  margin-top: 0.5rem;
}

button {
  font: inherit;
  padding: 0.35rem 0.75rem;
  border-radius: 6px;
  border: 1px solid var(--nogrok-preview-outline);
  background: var(--nogrok-preview-surface-rail);
  color: var(--nogrok-preview-on-surface);
  cursor: pointer;
}`,
  js: `const path = document.getElementById('curve')

document.getElementById('replay')?.addEventListener('click', () => {
  // Force reflow so removing/re-adding .anim retriggers CSS animation
  path?.classList.remove('anim')
  void path?.getBoundingClientRect()
  path?.classList.add('anim')
})`,
}

export default preset
